import React from "react"

import {FieldInlineEditableProps} from "../../../../render/inline-editable"
import FieldProject from "../project"

import {SelectParent_RenderType} from "../../../../../gd-ui/select-parent-new/@const";
import SelectParentNew from "../../../../../gd-ui/select-parent-new/select-parent-new";

const debug = false
// const debug = "FieldProject_InlineEditable"

export default function FieldProject_InlineEditable(props: FieldInlineEditableProps) {

    const value = props.model[props.field.fieldId]

    const field: FieldProject = props.field as FieldProject

    const onChange = (projectId: ID) => {
        if (props.onChange) props.onChange(projectId)
    }

    const onDeleteClick = () => {
        debug && console.log(debug, 'onDeleteClick')
        if (props.onChange) props.onChange(null)
    }

    debug && console.log(debug, 'render', props.field)

    return (
        <div className={Classes("ui5-field-with-delete-on-hover")}>

            <SelectParentNew className      = {props.className}
                             projectId      = {value}
                             parentsFor     = {field.parentsFor}
                             placeholder    = {field.placeholder}
                             renderType     = {SelectParent_RenderType.INLINE_EDITABLE}
                             disabled       = {props.disabled}
                             onChange       = {onChange}/>

            {props.field.clearButton && <div className="ui5-ico-trash red s-14" onClick={onDeleteClick}/>}
        </div>
    )

}
